<template>
  <v-dialog v-model="show" max-width="600" persistent>
    <div class="modal-container">
      <div class="modal-header">
        <div class="modal-text-container">
          <h1 class="modal-text-title">{{ adminText('organizationAll.edit_promo_code_5d0ee1b8', 'Edit promo code') }}</h1>
        </div>
        <v-icon color="#979797" class="close-icon" @click="cancel">close</v-icon>
      </div>
      <div class="main-container">
        <div class="form-container">
          <text-field
            id="name"
            v-model.trim="form.name"
            :label="adminText('organizationAll.name_57162c35', 'Name*')"
            type="text"
            :validator="$v.form.name"
          />
          <text-field
            id="code"
            v-model.trim="form.code"
            :label="adminText('organizationAll.unique_promo_code_bceba6f4', 'Unique Promo code*')"
            type="text"
            :validator="$v.form.code"
          />
          <div class="discount-row">
            <text-field
              v-if="form.discountType === 'PERCENTAGE'"
              id="discountPercentage"
              v-model.number="form.discountPercentage"
              :label="adminText('organizationAll.discount_percentage_89e75436', 'Discount percentage*')"
              type="number"
              :validator="$v.form.discountPercentage"
              append-icon="percent"
            />
            <text-field
              v-else
              id="discountAmount"
              v-model.number="form.discountAmount"
              :label="adminText('organizationAll.discount_amount_05ae2995', 'Discount amount*')"
              type="number"
              :validator="$v.form.discountAmount"
              append-icon="euro"
            />
            <select-field
              v-model="form.discountType"
              :label="adminText('organizationAll.discount_type_1aa10694', 'Discount type*')"
              :items="organizationOptions(discountTypeOptions, 'text')"
              item-render="text"
              item-select="value"
              :validator="$v.form.discountType"
            />
          </div>
          <div class="quantity-row">
            <text-field
              id="quantityPerTicket"
              v-model.number="form.quantityPerTicket"
              :label="adminText('organizationAll.quantity_44f6af69', 'Quantity')"
              type="number"
              :disabled="form.unlimited"
              :validator="$v.form.quantityPerTicket"
            />
            <div class="unlimited-container">
              <checkbox v-model="form.unlimited" :validator="$v.form.unlimited" color="#0277bd">
                <p class="unlimited-checkbox">{{ adminText('organizationAll.unlimited_quantity_d261fab6', 'Unlimited quantity') }}</p>
              </checkbox>
            </div>
          </div>
          <text-field
            id="ticketsPerOrder"
            v-model.number="form.ticketsPerOrder"
            :label="adminText('organizationAll.max_tickets_per_order_912792d6', 'Max Tickets per order*')"
            type="number"
            :validator="$v.form.ticketsPerOrder"
          />
          <div class="dates-container">
            <datetime-field v-model="form.from" :validator="$v.form.from" :label="adminText('organizationAll.start_date_ff99f5b5', 'Start date')" />
            <datetime-field
              v-model="form.to"
              :validator="$v.form.to"
              :label="adminText('organizationAll.end_date_89d10cd6', 'End date')"
              :min="form.from ? new Date(form.from).toISOString() : undefined"
            />
          </div>
          <div v-if="isPauseVisible" class="pause-container">
            <h1 class="modal-text-title">{{ adminText('organizationAll.pause_781961bc', 'Pause') }}</h1>
            <div class="dates-container">
              <datetime-field
                v-model="form.pauseFrom"
                :validator="$v.form.pauseFrom"
                :label="adminText('organizationAll.pause_start_date_c6c3497d', 'Pause start date*')"
                :min="form.from ? new Date(form.from).toISOString() : new Date().toISOString()"
                :max="form.to ? new Date(form.to).toISOString() : null"
                :error-messages="{
                  minDate: adminText('organizationAll.pause_start_should_be_during_the_promo_code_a_78958e87', 'Pause start should be during the promo code active period'),
                  maxDate: adminText('organizationAll.pause_start_should_be_before_the_pause_end_da_4d119662', 'Pause start should be before the pause end date'),
                }"
              />
              <datetime-field
                v-model="form.pauseTo"
                :validator="$v.form.pauseTo"
                :label="adminText('organizationAll.pause_end_date_b044a084', 'Pause end date*')"
                :min="
                  form.pauseFrom ? new Date(form.pauseFrom).toISOString() : new Date().toISOString()
                "
                :max="form.to ? new Date(form.to).toISOString() : null"
                :error-messages="{
                  minDate: adminText('organizationAll.pause_end_should_be_after_the_pause_start_dat_c20d9b26', 'Pause end should be after the pause start date'),
                  maxDate: adminText('organizationAll.pause_end_should_be_during_the_promo_code_act_edd4f9e5', 'Pause end should be during the promo code active period'),
                }"
              />
            </div>
            <main-button flat color="error" @click="handleRemovePause">
              <v-icon size="24" color="error" class="add-pause-icon">delete</v-icon>
              {{ adminText('organizationAll.remove_pause_904aaa1c', 'Remove pause') }}
            </main-button>
          </div>
          <main-button v-else flat @click="showPauseFields = true">
            <v-icon size="24" color="#0277BD" class="add-pause-icon">add</v-icon>
            {{ adminText('organizationAll.add_pause_159e078a', 'Add pause') }}
          </main-button>
        </div>
        <div class="buttons-container">
          <main-button outline @click="cancel">{{ adminText('organizationAll.cancel_4fd0653c', 'cancel') }}</main-button>
          <main-button :disabled="$v.form.$invalid" @click="handleSave">{{ adminText('organizationAll.save_13a4a113', 'save') }}</main-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import { maxValue, minValue, required, requiredIf } from 'vuelidate/lib/validators'

const discountTypeOptions = [
  { text: 'percentage (%)', value: 'PERCENTAGE' },
  { text: 'amount (€)', value: 'AMOUNT' },
]

export default {
  mixins: [OrganizationLocalization],
  name: 'edit-promo-code-modal',
  props: {
    show: Boolean,
    promoCode: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      discountTypeOptions,
      showPauseFields: false,
      form: {
        name: this.promoCode.name,
        code: this.promoCode.code,
        discountType: this.promoCode.discountType,
        discountPercentage: this.promoCode.discountPercentage || null,
        discountAmount: this.promoCode.discountAmount || null,
        quantityPerTicket: this.calculateQuantityPerTicket(),
        unlimited: this.calculateUnlimited(),
        ticketsPerOrder: this.promoCode.ticketsPerOrder,
        from: this.promoCode.from,
        to: this.promoCode.to,
        pauseFrom: this.promoCode.pauseFrom || null,
        pauseTo: this.promoCode.pauseTo || null,
      },
    }
  },
  validations() {
    return {
      form: {
        name: { required },
        code: { required },
        discountType: { required },
        discountPercentage: {
          required: requiredIf(({ discountType }) => discountType === 'PERCENTAGE'),
          maxValue: maxValue(100),
          minValue: minValue(0),
        },
        discountAmount: {
          required: requiredIf(({ discountType }) => discountType === 'AMOUNT'),
          minValue: minValue(0),
        },
        quantityPerTicket: {
          minValue: minValue(0),
          required: requiredIf(({ unlimited }) => !unlimited),
        },
        unlimited: { required: requiredIf(({ quantityPerTicket }) => !quantityPerTicket) },
        ticketsPerOrder: { required, minValue: minValue(1), maxValue: maxValue(10) },
        from: { required },
        to: { required },
        pauseFrom: { required: requiredIf(({ pauseTo }) => !!pauseTo) },
        pauseTo: { required: requiredIf(({ pauseFrom }) => !!pauseFrom) },
      },
    }
  },
  computed: {
    isPauseVisible() {
      return this.showPauseFields || Boolean(this.form.pauseFrom || this.form.pauseTo)
    },
  },
  watch: {
    'form.unlimited'(val) {
      if (val) {
        this.form.quantityPerTicket = null
      }
    },
  },
  methods: {
    cancel() {
      this.$v.$reset()
      this.$emit('update:show', false)
    },
    handleRemovePause() {
      this.showPauseFields = false
      this.form.pauseFrom = null
      this.form.pauseTo = null
      this.$v.form.pauseFrom.$reset()
      this.$v.form.pauseTo.$reset()
    },
    handleSave() {
      this.$v.$touch()
      if (!this.$v.form.$invalid) {
        this.$emit('save', { ...this.form })
      }
    },
    calculateQuantityPerTicket() {
      if (!this.promoCode || !this.promoCode.orderItems || !this.promoCode.orderItems.length) {
        return null
      }

      return this.promoCode.orderItems[0].OrderItemPromoCode.initialQuantity
    },
    calculateUnlimited() {
      return this.promoCode.orderItems.some(item => item.OrderItemPromoCode.unlimited)
    },
  },
}
</script>

<style scoped>
.modal-container {
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(51, 51, 51, 0.2);
  border-radius: 12px;
  padding: 24px 24px 32px 24px;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.modal-header {
  display: flex;
  align-items: baseline;
}
.modal-text-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.modal-text-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
}
.close-icon {
  cursor: pointer;
  user-select: none;
}
.main-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.form-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0%;
}
.discount-row {
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
}
.discount-row > * {
  flex: 1;
}
.quantity-row {
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  align-items: center;
}
.quantity-row > *:first-child {
  flex: 1;
}
.unlimited-container {
  display: flex;
  align-items: center;
}
.unlimited-checkbox {
  margin-bottom: 0;
}
.dates-container {
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  flex-wrap: wrap;
  justify-content: center;
}
.dates-container > * {
  flex: 1;
}
.buttons-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 16px;
}
.pause-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.add-pause-icon {
  flex-shrink: 0;
}

@media screen and (max-width: 600px) {
  .dates-container,
  .discount-row {
    flex-direction: column;
  }
}
</style>
